// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { linkLikeButtonCss } from "@conklin/App/SharedStyles/MyAccountDetailsStyles";
import { requestRmaButtonsStyles } from "@conklin/Overrides/Widgets/RequestRma/RequestRmaButtons";
import IconReturn from "@conklin/XDL/Icons/IconReturn";
import { generateButtonLinkStyle, mergeWithCss } from "@conklin/XDL/Utilities";
import X from "@insite/mobius/Icons/X";
import { css } from "styled-components";

requestRmaButtonsStyles.sendButton = {
    ...mergeWithCss(generateButtonLinkStyle(IconReturn), linkLikeButtonCss),
};

requestRmaButtonsStyles.cancelButton = {
    ...mergeWithCss(generateButtonLinkStyle(X), linkLikeButtonCss),
};

requestRmaButtonsStyles.buttonsContainer = {
    css: css`
        display: flex;
        justify-content: space-between;
        gap: 20px;
    `,
};
